import React, { useEffect, useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import "./LatestInsights.css";

import BlogImg1 from "../../assets/blog/blogImg1.png";
import BlogImg2 from "../../assets/blog/blogImg1.png";
import BlogImg3 from "../../assets/blog/blogImg1.png";

const blogData = [
  {
    id: 1,
    title: "A Guide to Mastering Investment Tracking",
    image: BlogImg1,
    slug: "a-guide-to-mastering-investment-tracking",
  },
  {
    id: 2,
    title: "Start Planning for Retirement Today",
    image: BlogImg2,
    slug: "start-planning-for-retirement-today",
  },
  {
    id: 3,
    title: "Regain Control with Debt Management",
    image: BlogImg3,
    slug: "regain-control-with-debt-management",
  },
];

const LatestInsights = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(".reveal-item");

            items.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add("reveal-visible");
              }, i * 150);
            });

            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
  }, []);

  return (
    <section ref={sectionRef} className="insights-section">
      <div className="insights-container">
        {/* Header */}
        <div className="insights-header reveal-item">
          <span className="insights-badge">FROM OUR BLOG</span>
          <h2 className="insights-title">Our latest insight & update</h2>
        </div>

        {/* Blog Cards */}
        <div className="insights-grid">
          {blogData.map((blog) => (
            <Link
              key={blog.id}
              to={`/blog/${blog.slug}`}
              className="insight-card reveal-item"
              onClick={() => window.scrollTo(0, 0)}
            >
              <div className="insight-img-wrapper">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="insight-img"
                />

                <div className="insight-gradient-overlay" />
              </div>

              <div className="insight-content">
                <h3 className="insight-card-title">{blog.title}</h3>

                <ArrowUpRight className="insight-card-icon" size={20} />
              </div>
            </Link>
          ))}
        </div>

        {/* Footer Button */}
        <div className="insights-footer reveal-item">
          <a
            href="https://blog.poonjimitra.com"
            target="_blank"
            rel="noopener noreferrer"
            className="more-blogs-btn"
          >
            More Blogs <ArrowUpRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default LatestInsights;
